/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type lotPricePerMeterSquared_product$ref = any;
type lotPrice_product$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentHeader_development$ref: FragmentReference;
declare export opaque type DevelopmentHeader_development$fragmentType: DevelopmentHeader_development$ref;
export type DevelopmentHeader_development = {|
  +title: ?string,
  +deliveryDate: ?string,
  +products: $ReadOnlyArray<{|
    +salePrice: ?number,
    +property: {|
      +numberOfRooms: ?number,
      +locality: ?string,
      +postcode: ?string,
    |},
    +$fragmentRefs: lotPrice_product$ref & lotPricePerMeterSquared_product$ref,
  |}>,
  +$refType: DevelopmentHeader_development$ref,
|};
export type DevelopmentHeader_development$data = DevelopmentHeader_development;
export type DevelopmentHeader_development$key = {
  +$data?: DevelopmentHeader_development$data,
  +$fragmentRefs: DevelopmentHeader_development$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentHeader_development",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deliveryDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "products",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "salePrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Property",
          "kind": "LinkedField",
          "name": "property",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "numberOfRooms",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "locality",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "postcode",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "lotPrice_product"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "lotPricePerMeterSquared_product"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DevelopmentProduct",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '5faea68d43a026de2f01b6061b2cc8d0';

export default node;
